import type { Mission } from '../missions.ts'

export const ice: Mission = {
  id: "ice",
  name: "U.S. Immigration and Customs Enforcement",
  short: "ICE",
  call: "Immigration",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.ice.gov/",
  established: 2003,
  palette: {
    primary: "#193966",
    secondary: "#971a2c",
    accent: "#6f8839",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:Seal_of_Immigration_and_Customs_Enforcement.svg",
  },
  motif: "shield",
  mission: {
    text: "Protect America through criminal investigations and enforcing immigration laws to preserve national security and public safety.",
    url: "https://www.ice.gov/mission",
  },
  fact: {
    text: "ICE was created in 2003 through a merger of the investigative and interior enforcement elements of the former U.S. Customs Service and the Immigration and Naturalization Service.",
    url: "https://www.ice.gov/about-ice",
  },
  seal: {
    file: "public/seals/ice.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_Immigration_and_Customs_Enforcement.svg",
  },
  identifier: {
    about: "https://www.ice.gov/about-ice",
    accessibility: "https://www.ice.gov/site-policies",
    foia: "https://www.ice.gov/foia",
    noFear: "https://www.ice.gov/leadership/ocrc",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.dhs.gov/performance-financial-reports",
    privacy: "https://www.ice.gov/site-policies",
  },
  media: {
    photos: [
      {
        file: "/media/ice-miami-seaport.jpg",
        small: "/media/ice-miami-seaport-sm.jpg",
        alt: "Two Homeland Security Investigations special agents, seen from behind in navy POLICE HSI shirts, ride a patrol boat past a container ship in the Port of Miami.",
        title: "HSI Marine Smuggling Group patrol of the Miami Seaport and Biscayne Bay, Florida, February 16, 2017",
        creator: "U.S. Immigration and Customs Enforcement",
        source: "https://commons.wikimedia.org/wiki/File:HSI_Miami_Special_Agents_Patrol_The_Miami_Seaport_and_Biscayne_Bay_(50044662541).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/ice-hsi-training.jpg",
        small: "/media/ice-hsi-training-sm.jpg",
        alt: "A column of Homeland Security Investigations agents in tactical gear walks down the ramp of the cargo ship Cape Isabel onto a pier after a training exercise.",
        title: "Homeland Security Investigations maritime training aboard the MV Cape Isabel, May 28, 2014",
        creator: "U.S. Immigration and Customs Enforcement",
        source: "https://commons.wikimedia.org/wiki/File:Homeland_Security_Investigations_(HSI)_(25007981577).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
